window.onWizzyScriptLoaded = function () {
  document.getElementById("expandable-search").focus();

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-results");
  changeTemplate("wizzy-search-pagination");
  changeTemplate("wizzy-common-select");
  changeTemplate("wizzy-search-empty-results");
        let showAll = false;

  if (window.innerWidth > 768) {
    changeTemplate("wizzy-autocomplete-topproducts");
    changeTemplate("wizzy-search-wrapper");

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {


    document.querySelectorAll('.wizzy-filters-facet-block')
    .forEach(block => {
        block.addEventListener('click', () => {
            const facetList = block.querySelector('.wizzy-facet-list'); // Select the child element
            if (!facetList) return; // Skip if `.wizzy-facet-list` does not exist

            let currentMaxHeight = parseInt(window.getComputedStyle(facetList).maxHeight, 10) || 0; // Get current max-height
            const targetMaxHeight = block.classList.contains('collapsed') ? 500 : 0; // Target max-height
            const increment = targetMaxHeight > currentMaxHeight ? 10 : -10; // Increment or decrement value

            // block.classList.toggle('collapsed'); // Toggle the collapsed class

            const interval = setInterval(() => {
                currentMaxHeight += increment;

                // Apply max-height to the element
                facetList.style.maxHeight = `${currentMaxHeight}px`;

                // Stop the interval when the target max-height is reached
                if ((increment > 0 && currentMaxHeight >= targetMaxHeight) || (increment < 0 && currentMaxHeight <= targetMaxHeight)) {
                    clearInterval(interval);
                    facetList.style.maxHeight = `${targetMaxHeight}px`; // Ensure exact max-height at the end
                }
            }, 10); // Adjust interval time for smoother or faster animation
        });
    });

    const facetBlocks = document.querySelectorAll(
      ".wizzy-filters-facet-block"
    );
    facetBlocks.forEach((block, index) => {
      if (index < 5) {
        block.classList.add("visible");
      }
    });

    const dropdownButton = document.querySelector(".wizzy-dropdown");

        dropdownButton.addEventListener("click", () => {
          if (showAll) {
            // Add `visible` class only to the top 5 elements
            facetBlocks.forEach((block, index) => {
              block.classList.toggle("visible", index < 5);
             dropdownButton.textContent = "Show More Filters +"; // Update button text

            });
          } else {
            // Add `visible` class to all elements
            facetBlocks.forEach((block) => block.classList.add("visible"));
            dropdownButton.textContent = "Show Less Filters -"; // Update button text

          }
          // Toggle the state
          showAll = !showAll;
        });
        return data;
      }
    );
  }

  if (window.innerWidth < 768) {
    document.body.addEventListener("click", function (event) {
      if (event.target.closest(".wizzy-sort-container")) {
        document.body.classList.add("wizzy-bg");
      }
      if (
        event.target.closest(".wizzy-common-select-overlay") ||
        event.target.closest(".wizzy-common-select-options")
      ) {
        //console.log(event.target);
        document.body.classList.remove("wizzy-bg");
      }
    });

    // Select the target element

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        const targetNode = document.querySelector(
          ".wizzy-autocomplete-wrapper"
        );

        if (targetNode) {
          const computedStyle = window.getComputedStyle(targetNode);

          if (computedStyle.display === "flex") {
            document.body.classList.add("wizzy-fixed-height");
            document.documentElement.classList.add("wizzy-fixed-height");
          }
        }

        //console.log(targetNode,"tttttttttttt")
        // Options for the observer (which mutations to observe)
        const config = {
          attributes: true,
          attributeFilter: ["style"],
        };
        const callback = function (mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "style"
            ) {
              const display = window.getComputedStyle(mutation.target).display;
              //console.log(display);
              if (display === "flex") {
                document.body.classList.add("wizzy-fixed-height");
                document.documentElement.classList.add("wizzy-fixed-height");
              } else {
                document.body.classList.remove("wizzy-fixed-height");
                document.documentElement.classList.remove("wizzy-fixed-height");
              }
            }
          }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
        return data;
      }
    );
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      //console.log(payload,"wizzy")
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      payload.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.filters.configs.displayAsDrawer = false;
      return payload;
    }
  );

  const labelMap = {
    "ADIRNYC JEWELRY": "ReMARKABLE Designs",
    "Adwar Casting": "ReMARKABLE Designs",
    "AFFINITY DESIGNS LLC": "ReMARKABLE Designs",
    "AFFORADABLE GEMS (NY) CORP.": "ReMARKABLE Designs",
    "AFFORDABLE GEMS (NY) CORP.": "eMARKABLE Designs",
    "ALICIA VAN FLETEREN": "ReMARKABLE Designs",
    "Amden Jewelry": "ReMARKABLE Designs",
    "American Jewelry Designs": "ReMARKABLE Designs",
    "ARMADANI": "ReMARKABLE Designs",
    "ARTISTRY, LTD": "ReMARKABLE Designs",
    "Arya&#39;s Collection": "ReMARKABLE Designs",
    "Ashi Diamonds, LLC": "ReMARKABLE Designs",
    "Atelier d&#39;Excellence Inc.": "ReMARKABLE Designs",
    "Atlantic Diamond Company": "ReMARKABLE Designs",
    "Barry Davidson, Inc.": "ReMARKABLE Designs",
    "Belgium Diamond": "ReMARKABLE Designs",
    "BELLARRI": "ReMARKABLE Designs",
    "Bhanderi Lab Grown Diamonds Inc.": "ReMARKABLE Designs",
    "C&C Jewelry Mfg., Inc.": "ReMARKABLE Designs",
    "Carrera Casting Corp.": "ReMARKABLE Designs",
    "China Pearl": "ReMARKABLE Designs",
    "Cool And Interesting": "ReMARKABLE Designs",
    "Coronation cultured pearls": "ReMARKABLE Designs",
    "Dalumi Diamond Corporation": "ReMARKABLE Designs",
    "DASSARI": "ReMARKABLE Designs",
    "David Kord (Formerly A & D)": "ReMARKABLE Designs",
    "Dharm International": "ReMARKABLE Designs",
    "Diamond Imports Inc.": "ReMARKABLE Designs",
    "Diamonds Forever of USA, Inc.": "ReMARKABLE Designs",
    "Divine LLC": "ReMARKABLE Designs",
    "ELAN JEWELS LLC": "ReMARKABLE Designs",
    "ELYSIAN DESIGNS INC": "ReMARKABLE Designs",
    "EMA Jewelry": "ReMARKABLE Designs",
    "Equity Diamond LLC Dba EDB": "ReMARKABLE Designs",
    "Essential Lab Grown Diamonds Inc.": "ReMARKABLE Designs",
    "Fischer Jewelry Designs": "ReMARKABLE Designs",
    "Frederick Goldman": "ReMARKABLE Designs",
    "FREMADA GOLD INC.": "ReMARKABLE Designs",
    "Gemsone corporation": "ReMARKABLE Designs",
    "Genuine Gems Corp.": "ReMARKABLE Designs",
    "GIFT Classic of New York": "ReMARKABLE Designs",
    "GIFT INOX Jewelry / SalesONE LLC": "ReMARKABLE Designs",
    "GIFT Kenro Industries- Ballast": "ReMARKABLE Designs",
    "GRAHAM INTERNATIONAL, INC.": "ReMARKABLE Designs",
    "Guild+Facet": "ReMARKABLE Designs",
    "H.j. Namdar": "ReMARKABLE Designs",
    "Harout R": "ReMARKABLE Designs",
    "HEERA MOTI": "ReMARKABLE Designs",
    "HERCO": "ReMARKABLE Designs",
    "HMA CREATIONS LLC": "ReMARKABLE Designs",
    "I. Reiss Company": "ReMARKABLE Designs",
    "INDIGO JEWELRY": "ReMARKABLE Designs",
    "International Diamond Distributors": "ReMARKABLE Designs",
    "JEWELS BY JACOB": "ReMARKABLE Designs",
    "JOCALIO GROUP LLC": "ReMARKABLE Designs",
    "Joshua J. Fine Jewelry": "ReMARKABLE Designs",
    "K.P. Sanghvi Inc.": "ReMARKABLE Designs",
    "KIran Gems NY Inc.": "ReMARKABLE Designs",
    "Lieberfarb, Inc.": "ReMARKABLE Designs",
    "LUVIRA JEWELS": "ReMARKABLE Designs",
    "M.K. Diamonds & Jewelry": "ReMARKABLE Designs",
    "Malakan Diamond Company": "ReMARKABLE Designs",
    "Marks Jewelers": "ReMARKABLE Designs",
    "Marks Jewelers Levittown": "ReMARKABLE Designs",
    "Marks Jewelers Montgomeryville": "ReMARKABLE Designs",
    "Marks Luxry Handbags": "ReMARKABLE Designs",
    "Marque": "ReMARKABLE Designs",
    "Mercury Ring": "ReMARKABLE Designs",
    "Metal Market Intl": "ReMARKABLE Designs",
    "Midas Chain": "ReMARKABLE Designs",
    "Mondrian Collection": "ReMARKABLE Designs",
    "Nemorofsky": "ReMARKABLE Designs",
    "Ninacci, Inc.": "ReMARKABLE Designs",
    "Ofer Mizrahi JEWELRY": "ReMARKABLE Designs",
    "ORIGINAL DESIGNS": "ReMARKABLE Designs",
    "OVERNIGHT MOUNTINGS": "ReMARKABLE Designs",
    "Overseas Direct, Member of Salant Group": "ReMARKABLE Designs",
    "Quality Gold": "ReMARKABLE Designs",
    "R.A. Riam Group Inc.": "ReMARKABLE Designs",
    "REVELATION-Craft Lab Grown Diamonds": "ReMARKABLE Designs",
    "Royal Jewelry Manufacturing Inc.": "ReMARKABLE Designs",
    "Royal Pearl": "ReMARKABLE Designs",
    "S. KASHI": "ReMARKABLE Designs",
    "Saban Onyx": "ReMARKABLE Designs",
    "SABRINA DESIGNS CO.": "ReMARKABLE Designs",
    "Samuel B. Collection": "ReMARKABLE Designs",
    "Sandberg & Sikorsk": "ReMARKABLE Designs",
    "SDC Creations": "ReMARKABLE Designs",
    "SMILING ROCKS, INC": "ReMARKABLE Designs",
    "Speidel Inc.": "ReMARKABLE Designs",
    "Stock Jewlvision - Made in Montgomeryville": "ReMARKABLE Designs",
    "Stuller": "ReMARKABLE Designs",
    "Universal Pacific Diamonds": "ReMARKABLE Designs",
    "Venetti": "ReMARKABLE Designs",
    "VIMCO DIAMOND CORP.": "ReMARKABLE Designs",
    "VLORA": "ReMARKABLE Designs",
    "Yerushalmi Brother": "ReMARKABLE Designs",
    "Alpha Labgrown Diamonds": "PureMark",
    "ALTR Puremark Laboratory Grown": "PureMark",
    "DIALOG SOLUTIONS INC": "PureMark Powered by Clarity",
    "Marks Estate Department 2": "ReMARKable Estate",
    "Marks Estate Dept 1": "ReMARKable Estate",
    "OFF THE STREET - HEADQUARTERS - MONTGOMERYVILLE PA": "ReMARKable Estate",
    "OFF THE STREET STORE 2 - MT. LAUREL NJ": "ReMARKable Estate",
    "A. JAFFE": "A. Jaffe",
    "CROWN RING": "Crown Ring",
    "Elise Paige Jewelry": "EP Jewelry",
    "FANA": "Fana",
    "Forevermark USA": "Forevermark",
    "John Hardy USA Inc.": "John Hardy",
    "LIGHTBOX JEWELRY INC": "Lightbox",
    "Marks 89 Jewlvision": "Marks 89",
    "MARKS SIGNATURE": "Marks Signature",
    "Rembrandt": "Rembrandt Charms",
    "Sylvie Collection (Spectrum Diamonds)": "Sylvie",
    "VERRAGIO": "Verragio",
    "VIANNA BRASIL": "Vianna Brasil"
  };

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        let attributes = product.attributes;
        attributes.forEach((attribute) => {
          if (attribute.id === "product_vendor") {
            const value = attribute.values[0].value[0];

            // Use the map to find the corresponding new label, or fallback to the original value if not present
            product.vendor = labelMap[value] || value;
          }
        });
      });
      return data;
    }
  );

  document.body.addEventListener("click", function (event) {
    if (
      event.target.matches(".wizzy-facet-head") ||
      event.target.matches(".facet-head-title")
    ) {
      // Find the closest ancestor with the class .wizzy-filters-facet-block.facet-block-top
      const closestBlock = event.target.closest(
        ".wizzy-filters-facet-block.facet-block-top"
      );
      if (closestBlock) {
        let left = closestBlock.offsetLeft;
        document
          .querySelectorAll(".wizzy-facet-list")
          .forEach(function (element) {
            element.style.left = left - 25 + "px";
          });
      }
    }
  });

  document.body.addEventListener("click", function (event) {
    if (event.target.closest(".wizzy-common-select-selector")) {
      document.querySelector(".wizzy-filters-bg").style.display = "none";
    }
  });
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;

  oldDiv.text = newDiv;
};
